<template>
  <div class="page-padding">
      <slot/>
  </div>
</template>

<script>


export default {
  name: 'page-padding',
  data:function(){
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.page-padding{
  padding:10px;
}


</style>
